import { render, staticRenderFns } from "./Soluvenue.vue?vue&type=template&id=21b96ecf&scoped=true&"
import script from "./Soluvenue.vue?vue&type=script&lang=js&"
export * from "./Soluvenue.vue?vue&type=script&lang=js&"
import style0 from "./Soluvenue.vue?vue&type=style&index=0&id=21b96ecf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b96ecf",
  null
  
)

export default component.exports